export const marketingTags = [
  'marketing_assignLead',
  'marketing_addDeleteReview',
] as const;
